import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import Modal, { ModalBody } from "@redbubble/design-system/react/Modal";
import Box from "@redbubble/design-system/react/Box";
import Text from "@redbubble/design-system/react/Text";
import Button from "@redbubble/design-system/react/Button";
import * as constants from "@redbubble/design-system/react/constants";
import messages from "./messages";
import { intlPropType } from "../../../../../../lib/propTypes";
import styles from "./DeleteCommentModel.scss";

const DeleteCommentModel = ({
  isOpen,
  closeModal,
  deleteComment,
  deleteCommentLoading,
  intl,
}) => (
  <Modal
    accessibleTitle={intl.formatMessage(messages.delete)}
    size={constants.SMALL}
    open={isOpen}
    onCloseRequested={closeModal}
    getApplicationNode={() => document.getElementById("app")}
  >
    <ModalBody>
      <Box marginBottom="l">
        <FormattedMessage {...messages.delete}>
          {(text) => (
            <Box marginBottom="m">
              <Text type="display3" display="block">
                {text}
              </Text>
            </Box>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.modelContent1}>
          {(text) => (
            <Text type="body" display="block">
              {text}
            </Text>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.modelContent2}>
          {(text) => (
            <Text type="body" display="block">
              {text}
            </Text>
          )}
        </FormattedMessage>
      </Box>
      <Box className={styles.line} />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        paddingTop="l"
      >
        <FormattedMessage {...messages.cancel}>
          {(text) => (
            <Box marginRight="m">
              <Button onClick={closeModal}>{text}</Button>
            </Box>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.delete}>
          {(text) => (
            <Box>
              <Button
                onClick={deleteComment}
                intent={constants.DESTRUCTIVE}
                loading={deleteCommentLoading}
                strong
              >
                {text}
              </Button>
            </Box>
          )}
        </FormattedMessage>
      </Box>
    </ModalBody>
  </Modal>
);

DeleteCommentModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired,
  deleteCommentLoading: PropTypes.bool.isRequired,
  intl: intlPropType.isRequired,
};

export default injectIntl(DeleteCommentModel);
